/* eslint-disable arrow-parens */
<template>
  <tr>
    <td style="text-transform:capitalize;">{{template.title}}</td>
    <td class="text-center">
      <!-- <button
        class="btn btn-sm mw-auto btn-success mr-1"
        @click="changeDefaultStatus()"
      >{{is_default}}</button> -->
      <toggle-button @change="changeDefaultStatus" v-model="is_default_val" :value="is_default_val" color="#17a2b8" :sync="is_default_val" />
    </td>
    <td class="text-center">
      <button class="btn btn-sm mw-auto btn-info mr-1" @click="load(template.search)">反映</button>
    </td>
    <td class="text-center">
      <button class="btn btn-sm mw-auto btn-info mr-1" @click="openSearchParams(template)">編集</button>
    </td>
    <td class="text-center">
      <button class="btn btn-sm mw-auto btn-danger mr-1" v-b-modal="template.id">
        <i class="fa fa-trash"></i>
      </button>
    </td>
    <b-modal
      :id="template.id"
      ok-variant="outline-danger mw-auto"
      cancel-variant="outline-primary mw-auto"
      button-size="sm"
      cancel-title="キャンセル"
      ok-title="OK"
      @ok="destroy"
      hide-header
    >
      <div class="text-center p-4">
        <div class="dlt-block">
          <i class="fa fa-trash" aria-hidden="true"></i>
          <p>検索条件を削除しますか</p>
        </div>
      </div>
    </b-modal> 
    <EditSearchTemplate :template="template" :showModal="isModalEdit" v-if="isModalEdit" @hideSearchModal="hideSearchModal" />
  </tr>
</template>

<script>
import EditSearchTemplate from "./EditSearchTemplate.vue";
import Api from '@/config/api';
import ApiService from '@/service/apiService';
import { mapMutations, mapActions } from 'vuex';
import mutations from '@/config/mutations';
import actions from '@/config/actions';

export default {
  name: 'TemplateRow',
  props: ['templateData'],
  components: { EditSearchTemplate },
  data() {
    return {
      template: this.templateData,
      is_default_val: this.templateData.is_default,
      isModalEdit: false
    };
  },
  watch: {
    templateData: {
      handler(newTemplateData) {
        // console.log(newTemplateData);
        // Update the local template data when the prop changes
        this.template = newTemplateData;
      },
      immediate: true, // Trigger the handler immediately when the component is created
    },
  },
  computed: {
    is_default() {
      return this.template.is_default ? 'はい' : 'いいえ';
    },
  },
  methods: {
    ...mapActions([actions.applicant.LOAD_APPLICANTS]),
    ...mapMutations([
      mutations.applicant.CHANGE_SEARCH_PARAMS,
      mutations.applicant.TOGGLE_SEARCH_MODAL,
      'mutateSearchTemplateAfterChange',
      'unsetTemplate',
      'setDefaultLoaded'
    ]),
    hideSearchModal(){
      this.isModalEdit = false;
    },
    destroy() {
      ApiService.delete(Api.endpoints.DELETE_TEMPLATE(this.template.id)) // eslint-disable-next-line
        .then(() => {
          this.unsetTemplate(this.template);
        })
        .catch((error) => {
          this.parseErrorResponse(error)
        });
    },
    async load(parameters) {
      this.setDefaultLoaded(true);
      this[mutations.applicant.CHANGE_SEARCH_PARAMS](parameters);
      this.$router.push({ path: '/applicant' });
    },
    openSearchParams(parameters) {
      this.isModalEdit = true;
    },
    changeDefaultStatus() {
      ApiService.get(Api.endpoints.TEMPLATE_STATUS_CHANGE(this.template.id)) // eslint-disable-next-line
        .then(({ data }) => {
          this.mutateSearchTemplateAfterChange(data.data);
        })
        .catch(({ response }) =>  this.parseErrorResponse(error));
    },
  },
  
};
</script>

<style scoped>

.btn-info{
  background: #036d6c;
}
.mw-auto{
  min-width:70px;
  padding:5px;
}
.dlt-block {
  text-align: center;
}

.dlt-block i {
  font-size: 30px;
  color: red;
  margin-bottom: 10px;
}
</style>
